import PropTypes from 'prop-types';
import React from 'react';
import memoize from 'memoize-one';

import ProfileCardPopup from './profileCardPopup.jsx';
import { PseudoLink } from '../../libs/routing';
import BoosterClub from '../users/boosterClubMegaphone.jsx';

function getStyles (props) {
	return {
		container: {
			...(props.style || {}),
			display: 'inline-block',
		},
		link: {
			color: 'inherit',
			':hover': {
				color: 'inherit',
			},
		},
	};
}

class InlineUser extends React.PureComponent {
	constructor (props) {
		super(props);
		this.getStyles = memoize(getStyles);
	}

	componentDidMount () {
		if (!this.props.user && this.props.getUser) {
			this.props.getUser();
		}
	}

	render () {
		if (!this.props.user) { return null; }
		const styles = this.getStyles(this.props);

		return (
			<div style={styles.container}>
				<ProfileCardPopup
					tooltipParams={this.props.tooltipParams}
					user={this.props.user}
					userRank={this.props.userRank}
				>
					<PseudoLink
						style={styles.link}
						to={this.props.user.relativeUrl}
					>
						{this.props.user.displayName}
					</PseudoLink>
				</ProfileCardPopup>
				{!this.props.hideBooster && (
					<BoosterClub user={this.props.user} />
				)}
			</div>
		);
	}
}
InlineUser.propTypes = {
	getUser: PropTypes.func,
	hideBooster: PropTypes.bool,
	style: PropTypes.object,
	tooltipParams: PropTypes.object,
	user: PropTypes.object,
	userRank: PropTypes.object,
};

export default InlineUser;
